{
  "settings": {
    "audit": {
      "dataSources": "Datové zdroje",
      "functions": "Funkce",
      "generalSettings": "Základní nastavení",
      "modules": "Moduly",
      "notificationTemplates": "Notifikační šablony",
      "numbers": "Počet dnů uchování audit logů",
      "roles": "Role",
      "tables": "Tabulky",
      "templates": "Šablony",
      "title": "Protokol auditu",
      "users": "Uživatelé"
    },
    "colors": {
      "primary": "Primární text",
      "primaryBG": "Primární pozadí",
      "secondary": "Sekundární text",
      "secondaryBG": "Sekundární pozadí",
      "title": "Barvy"
    },
    "dashboard": {
      "addKPI": "Přidat KPI",
      "addWidget": "Přidat agendu",
      "noKPI": "Nejsou nadefinované žádné KPI",
      "requiredKPI": "KPI musí obsahovat alespoň jednu položku.",
      "noAgendas": "Nejsou nadefinované žádné agendy",
      "requiredAgendas": "Přehledy musí obsahovat alespoň jednu položku.",
      "placeholder": "Nastavení dashboardu",
      "title": "Nastavení dashboardu",
      "modules": "Moduly",
      "agendas": "Agendy",
      "views": "Přehledy",
      "color": "Barva",
      "agendaViewSettings": "Nastavení přehledu agendy",
      "kpiSettings": "Nastavení KPI",
      "deleteDashboard": "Smazat dashboard",
      "deleteDashboardConfirmationText": "Toto smaže současný dashboard a všechna jeho nastavení. Jste si jisti, že chcete pokračovat?",
      "sourceSelect": "Zdroj",
      "heliosSqlScript": "Helios SQL skript",
      "view": "Přehled",
      "link": "Odkaz",
      "linkUrl": "URL odkazu",
      "linkText": "Nadpis odkazu",
      "heliosDataSource": "Helios datový zdroj",
      "heliosScript": "Helios skript",
      "itemsSettingRequired": "Všechny položky musí být nastaveny",
      "dashboardDataError": "Chyba při načítání dat dashboardu",
      "agendaView": "Přehled agendy",
      "kpiItem": "KPI",
      "notification": "Nepřečtené informace",
      "notificationWithAction": "Nevyřízené úkoly",
      "groupByModule": "Seskupovat dle modulu",
      "showRecordCount": "Zobrazit počet záznamů"
    },
    "email": {
      "placeholder": "Napiště e-mail",
      "text": "E-mail",
      "title": "E-mail pro hlášení chyb",
      "required": "Email je povinný",
      "invalid": "Email je neplatný"
    },
    "contactEmail": {
      "invalid": "Email je neplatný"
    },
    "date": {
      "from": "Je vyžadována platnost od",
      "to": "Je vyžadováno platné do",
      "minDate": "Platné do musí být větší než Platné od",
      "today": "Platné do musí být po dnešku"
    },
    "error": {
      "loginRequired": "Může být vybrán pouze jeden"
    },
    "login": {
      "google": "Google login",
      "microsoft": "Microsoft login",
      "title": "Nastavení způsobu přihlašování",
      "warning": "Měníte způsob přihlášení. Po uložení změn mohou být způsobeny problémy s přístupem do aplikace."
    },
    "templates": {
      "text": "Počet záznamů v pohledech",
      "title": "Nastavení pohledů"
    },
    "user": {
      "profile": "Profil",
      "pageSize": {
        "title": "Nastavení pohledů",
        "label": "Počet záznamů v pohledech"
      },
      "fastSignIn": {
        "title": "Rychlé přihlášení",
        "recommended": "Doporučeno",
        "changePin": "Změnit PIN kód",
        "pin": {
          "title": "PIN kód",
          "subtitle": "6místný PIN – rychlý a bezpečný"
        },
        "biometry": {
          "title": "Face ID",
          "subtitle": "Přihlásit se pohledem – okamžité"
        },
        "fingerprint": {
          "title": "Otisk prstu",
          "subtitle": "Přihlásit se otiskem prstu – okamžité"
        },
        "none": {
          "title": "Žádné",
          "subtitle": "Nepoužívat rychlé přihlášení"
        },
        "actionRequired": {
          "title": "Vyžadována akce",
          "body": "Nastavte způsob rychlého přihlášení. Aplikaci můžete zatím používat bez omezení."
        },
        "confirmNone": {
          "title": "Vypnout rychlé přihlášení?",
          "body": "Opravdu chcete vypnout rychlé přihlášení? Aplikaci již neodemknete pomocí PIN nebo biometrie."
        }
      }
    },
    "contacts": {
      "showContacts": "Zobrazovat Rozdělovník",
      "title": "Rozdělovník"
    }
  },
  "users": {
    "adminPermissions": "Administrátorská oprávnění",
    "impersonate": "Impersonovat",
    "cancel_impersonate": "Zrušit impersonaci",
    "cancel_substitution": "Vrátit do mého zobrazení",
    "currently_substituting": "Aktuálně zastupuji uživatele:",
    "start_impersonation_error": "Nepodařilo se spustit impersonaci",
    "stop_impersonation_error": "Nepodařilo se zrušit impersonaci",
    "validToBeforeValidFrom": "Platnost do musí být větší než platnost od"
  },
  "roles": {
    "table": {
      "name": "Název role"
    },
    "deleteConfirmation": "Opravdu chcete smazat vybrané role? Tato akce je nevratná.",
    "selectByTag": "Po skupinách",
    "selectIndividually": "Jednotlivě",
    "tags": {
      "title": "Štítky",
      "addTag": "Přidat nebo vybrat štítek",
      "placeholder": "Zadejte pro přidání nového štítku nebo vyberte existující"
    }
  },
  "modules": {
    "name": "Název",
    "deleteConfirmation": "Opravdu chcete smazat vybrané moduly? Tato akce je nevratná.",
    "renameModule": "Přejmenovat modul",
    "attachModule": "Připnout modul",
    "dashboardSettings": "Nastavení dashboardu",
    "isChildModule": "Je podřízený modul",
    "parentModule": "Nadřazený modul",
    "selectParentModule": "Vyberte nadřazený modul"
  },
  "assistants": {
    "addTitle": "Přidat asistenta",
    "editTitle": "Upravit asistenta",
    "search": "Hledat asistenty",
    "labelSection": "Název",
    "descriptionSection": "Popis",
    "idSection": "ID asistenta",
    "vsgAssistantId": "VSG ID asistenta",
    "deleteConfirmation": "Opravdu chcete smazat tohoto asistenta? Tato akce je nevratná.",
    "description_En": "Popis (EN)",
    "description_Sk": "Popis (SK)",
    "description_Cs": "Popis (CZ)"
  },
  "substitutability": {
    "showToUsers": "Zobrazit možnost zastupitelnosti uživatelům",
    "showInSubstituted": "Zobrazovat v zastupovaných uživatele",
    "options": {
      "visible": "Ano",
      "hidden": "Ne"
    },
    "listingType": {
      "None": "Žádný",
      "AllUsers": "Všechny",
      "OneUserRole": "S jednou stejnou rolí",
      "AllUserRoles": "Se stejnými rolemi"
    }
  }
}
